import { render } from "./_task.vue?vue&type=template&id=91ba43a0&lang=pug"
import script from "./_task.vue?vue&type=script&lang=js"
export * from "./_task.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__